import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import styled from "styled-components";
import Mainlayout from "../../components/Mainlayout";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import latestproduct from "./../../data/latestproduct.json";
import LatestAddition from "../../components/latestAddition/LatestAddition";
import AppBreadcrumbs from "../../components/breadcrumbs/AppBreadcrumbs";

// Styled Components with Media Queries
const Container = styled.div`
  padding-left: 100px;
  padding-right: 100px;
  flex: 1 0 auto;

  @media (max-width: 575.98px) {
    padding-left: 20px;
    padding-right: 20px;
  }

  @media (min-width: 576px) and (max-width: 767.98px) {
    padding-left: 40px;
    padding-right: 40px;
  }

  @media (min-width: 768px) and (max-width: 991.98px) {
    padding-left: 60px;
    padding-right: 60px;
  }

  @media (min-width: 992px) and (max-width: 1199.98px) {
    padding-left: 80px;
    padding-right: 80px;
  }
`;

const MainContainer = styled.div`
  // font-family: Arial, sans-serif;
  padding-top: 40px;
  padding-bottom: 40px;
  background-color: "red";
  
  
`;

const GridContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  max-width: 1000px;
  margin: 0 auto;
  justify-content: center;

  & > * {
    flex: 1 1 200px;
    max-width: 1fr;
    min-width: 200px;
    box-sizing: border-box;
  }

  /* Mobile S (320px width) adjustments */
  @media (max-width: 320px) {
    & > * {
      min-width: 80px;
    }
    gap: 5px;
  }

  /* Mobile (375px width) adjustments */
  @media (max-width: 375px) {
    & > * {
      min-width: 100px;
    }
    gap: 10px;
  }

  /* Mobile (425px width) adjustments */
  @media (max-width: 425px) {
    & > * {
      min-width: 120px;
    }
    gap: 12px;
  }

  /* Tablet (768px width) adjustments */
  @media (max-width: 768px) {
    & > * {
      min-width: 150px;
    }
    gap: 15px;
  }

  /* Laptop (1024px width) adjustments */
  @media (max-width: 1024px) {
    & > * {
      min-width: 180px;
    }
    gap: 18px;
  }

  /* Default (above 1024px) adjustments */
  @media (min-width: 1025px) {
    & > * {
      min-width: 200px;
    }
  }
`;

const GridItem = styled.div`
  text-align: center;
  cursor: pointer;
  transition: transform 0.2s ease;
  background: white;
  border-radius: 12px;
  border: 1px solid ${window.ENV.GENERAL.PRODUCT_GRID_BOARDER_COLOR};
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  padding: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 280px;

  &:hover {
    transform: scale(1.05);
  }
`;

const GridItemImageContainer = styled.div`
  border-radius: 8px;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  

  @media (max-width: 575.98px) {
    height: 150px;
  }

  @media (min-width: 576px) and (max-width: 767.98px) {
    height: 180px;
  }
`;

const GridItemImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`;

const GridItemLabel = styled.p`
  font-size: 14px;
  font-weight: bold;
  margin-top: 10px;
  color: #333;
`;

const Loading = styled.p`
  font-size: 16px;
  color: #555;
`;

const Latestwidth = styled.div`
  background-color: #f4f4f4;
  margin-top: 0;
  padding-top: 0;

  @media (max-width: 575.98px) {
    margin-top: 0;
  }

  @media (min-width: 576px) and (max-width: 767.98px) {
    margin-top: 0;
  }

  @media (min-width: 768px) and (max-width: 991.98px) {
    margin-top: 0;
  }
`;

const Containermodify = styled.div``;
const API_URL = process.env.REACT_APP_API_URL;
const url = `${API_URL}/${window.ENV.TENANT_NAME}/${window.ENV.DATA_SOURCE}/data`;

const Mainpage = () => {
  const {categoryName } = useParams();
  console.log("categoryName", categoryName)
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [latestData, setLatestData] = useState(null);

  const totalItems = latestData ? latestData.length : 0; // Total number of items
  const itemsPerSlide = window.ENV.LATEST_ADDITION_TOTAL_COUNT; // Number of items per slide
  const [currentIndex, setCurrentIndex] = useState(0);

  // Next slide function with smooth transition
const nextSlide = () => {
  setCurrentIndex((prevIndex) => (prevIndex + 1) % totalItems);
};

// Previous slide function with smooth transition
const prevSlide = () => {
  setCurrentIndex((prevIndex) => (prevIndex - 1 + totalItems) % totalItems);
};

// Calculate visible items for the current slide
const visibleItems = latestData
  ? Array.from({ length: itemsPerSlide }, (_, i) => {
      const index = (currentIndex + i) % totalItems; // Ensure index wraps around
      return latestData[index];
    })
  : [];

// Calculate the translateX value for smooth scrolling
const transformValue = `translateX(-${(currentIndex * 100) / itemsPerSlide}%)`;

  let modifiedCategoryName = categoryName ? categoryName : "root";
  const dataKey = window.ENV.GOOGLE_SHEET_ID;
  const requestBody = {
    range: "Category!A1:F300",
    dataKey: dataKey,
    filters: {
      categoryParentName: [modifiedCategoryName],
    },
  };

  useEffect(() => {
    axios
      .post(url, requestBody, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("API Response:", response.data);
        setData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        const errorMessage = error.response
          ? error.response.data.message
          : error.message;
        setError(errorMessage || "An error occurred while fetching the data.");
      });
  }, [categoryName]);

 
  const url2 = `${API_URL}/${window.ENV.TENANT_NAME}/${window.ENV.DATA_SOURCE}/data`;
  const requestBody2 = {
    range: "Product!A1:" + window.ENV.TOTAL_PRODUCTS,
    dataKey: dataKey,
    filters: {},
  };
  useEffect(() => {
    axios
      .post(url2, requestBody2, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        const data = response.data;
        const lastFiveItems = data.slice(-5);
        console.log("Last 5 items:", lastFiveItems);
        setLatestData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        const errorMessage = error.response
          ? error.response.data.message
          : error.message;
        setError(errorMessage || "An error occurred while fetching the data.");
      });
  }, [categoryName]);

  const handleGridItemClick = (itemName, isLeaf, filter) => {
    if (isLeaf === "y") {
      navigate(`/productlist/${encodeURIComponent(itemName)}`, {
        state: {
          selectedFilter: filter,
          subcategoryPath: `productlist/${categoryName}`,
        },
      });
    } else {
      navigate(`/category/${encodeURIComponent(itemName)}`, {});
    }
  };

  return (
    <Mainlayout categoryName={modifiedCategoryName}>
      <Container style={{ backgroundColor: window.ENV.GENERAL.BACKGROUND_COLOR || "white" }}>
        <MainContainer>
          <div>
            {data ? (
              <GridContainer>
                {data.map((item, index) => 
                  item ?
                  <GridItem
                    key={index}
                    onClick={() =>
                      handleGridItemClick(
                        item.categoryName || "unknown",
                        item.isLeaf,
                        item.filter
                      )
                    }
                  >
                    <GridItemImageContainer>
                      <GridItemImage
                        src={`${window.ENV.SERVER_URL}${item.imageUrl}`}
                        alt={item.categoryLabel || "No label available"}
                      />
                    </GridItemImageContainer>
                    <GridItemLabel>
                      {item.categoryLabel || "No label available"}
                    </GridItemLabel>
                  </GridItem> : null
                )}
              </GridContainer>
            ) : (
              <Loading>Loading...</Loading>
            )}
          </div>
        </MainContainer>
        {window.ENV.SHOW_LATEST_ADDITION && latestData && latestData.length > 0 && (
        <Latestwidth className="latestwidth">
          <Containermodify>
            <LatestAddition
              visibleItems={visibleItems}
              nextSlide={nextSlide}
              prevSlide={prevSlide}
            />
          </Containermodify>
        </Latestwidth>
      )}
      </Container>
  
    </Mainlayout>
  );
};

export default Mainpage;
